import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconReviewFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M22 13.9997C22 14.552 21.5528 15.0001 20.9997 15.0001C20.4466 15.0001 19.9994 14.552 19.9994 13.9997C19.9994 9.58862 16.4108 5.99976 12 5.99976C7.58918 5.99976 4.00058 9.58862 4.00058 13.9997C4.00058 14.552 3.55246 15.0001 3.00029 15.0001C2.44811 15.0001 2 14.552 2 13.9997C2 8.48601 6.48666 4 12 4C17.5133 4 22 8.48601 22 13.9997ZM16.2918 12.8334C15.0721 12.8334 14.0831 11.5087 14.0831 9.87461C14.0831 9.3674 14.1872 8.8977 14.355 8.48049C13.6322 8.17203 12.8363 7.99954 12 7.99954C8.68599 7.99954 6.00024 10.6855 6.00024 13.9998C6.00024 17.3141 8.68599 20 12 20C15.3141 20 17.9999 17.3141 17.9999 13.9998C17.9999 13.3482 17.893 12.7228 17.7008 12.135C17.3174 12.5644 16.8299 12.8334 16.2918 12.8334Z",
		fill: "currentColor"
	})
});
export default SvgIconReviewFill;
